import { utils, generatePathInfo } from "@alife/cone-arms-core";
import { observeDomTreeMutation } from "./utils";
var supportedEntryType = utils.supportedEntryType, hookHistory = utils.hookHistory, hookHashChange = utils.hookHashChange;
var reportedCacheMap = {};
// 用于单页切换后重新计时
var watchStartTime = 0;
export var watchImportantElementRender = function watchImportantElementRender(callback) {
    var enhanceElementTimingObserve = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!supportedEntryType("element")) {
        return function() {};
    }
    var observer = new PerformanceObserver(function(list) {
        var entries = list.getEntries();
        entries.forEach(function(entry) {
            var _entry;
            if (((_entry = entry) === null || _entry === void 0 ? void 0 : _entry.startTime) > 0 && entry.identifier && entry.element && !reportedCacheMap[entry.identifier]) {
                var renderTime = watchStartTime > 0 ? new Date().getTime() - watchStartTime : entry.startTime;
                callback(entry, renderTime);
            }
        });
    });
    var mutationObserver;
    try {
        observer.observe({
            type: "element",
            buffered: true
        });
        if (typeof MutationObserver !== "undefined" && enhanceElementTimingObserve) {
            observeDomTreeMutation(function() {
                document.querySelectorAll("[elementtiming]").forEach(function(el) {
                    if (!el) {
                        return;
                    }
                    var identifier = el.elementTiming;
                    if (!el.__hadReported && identifier && !reportedCacheMap[identifier]) {
                        var renderTime = watchStartTime > 0 ? new Date().getTime() - watchStartTime : Math.ceil(performance.now());
                        callback({
                            identifier: identifier,
                            element: el
                        }, renderTime);
                    }
                });
                return false;
            });
        }
    } catch (e) {
    // ignore error
    }
    return function() {
        observer.disconnect();
        if (mutationObserver && typeof mutationObserver.disconnect === "function") {
            mutationObserver.disconnect();
        }
    };
};
export var logElementRender = function(core, entry, renderTime) {
    var _ref = entry || {}, element = _ref.element, identifier = _ref.identifier;
    if (!identifier || !element || reportedCacheMap[identifier]) {
        return;
    }
    reportedCacheMap[identifier] = true;
    element.__hadReported = true;
    var xpath = generatePathInfo(element).xpath;
    if (!xpath) {
        return;
    }
    core.log({
        type: "bizImportantElementRenderPerformance",
        p1: identifier,
        p2: Math.ceil(renderTime),
        p3: xpath,
        // 标记是否是单页切换后的重要元素曝光
        p4: watchStartTime > 0 ? "Y" : "N"
    });
};
export var initElementRenderObserver = function(core) {
    var enhanceElementTimingObserve = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var currentUrl = core.getUrl();
    // 每个页面最多观察2分钟
    var maxWatchTimePerPage = 2 * 60 * 1000;
    var disconnectTimer;
    var disconnect = null;
    var invokeInitWatcher = function() {
        if (disconnectTimer) {
            clearTimeout(disconnectTimer);
        }
        if (typeof disconnect !== "function") {
            disconnect = watchImportantElementRender(function(entry, renderTime) {
                logElementRender(core, entry, renderTime);
            }, enhanceElementTimingObserve);
        }
        disconnectTimer = setTimeout(function() {
            disconnect && disconnect();
            disconnect = null;
        }, maxWatchTimePerPage);
    };
    var hookFn = core.getConfig().spaRouteType === "hash" ? hookHashChange : hookHistory;
    var unHook = hookFn(function() {
        var newUrl = core.getUrl();
        if (newUrl !== currentUrl) {
            watchStartTime = new Date().getTime();
            currentUrl = newUrl;
            // 清空缓存
            Object.keys(reportedCacheMap).forEach(function(key) {
                delete reportedCacheMap[key];
            });
            invokeInitWatcher();
        }
    });
    invokeInitWatcher();
    return function() {
        disconnect && disconnect();
        if (typeof unHook === "function") {
            unHook();
        }
    };
};

 //# sourceMappingURL=element-render-observe.js.map